import { Box } from '@material-ui/core'
import { Label } from '@noco/http-client/lib/noco'
import React from 'react'
import { Typography } from 'src/components/atoms'
import { PopupTemplate } from '..'

export interface ModalLabelDeleteProps {
  open: boolean
  label?: Label
  onClose: () => void
  onConfirm: () => void
}

export const ModalLabelDelete = ({ open, label, onClose, onConfirm }: ModalLabelDeleteProps) => {
  return (
    <PopupTemplate
      open={open}
      title="ラベルの削除"
      hasClose
      hasCancel
      cancelButtonLabel="キャンセル"
      onClose={onClose}
      hasConfirm
      onConfirm={onConfirm}
      confirmButtonLabel="削除"
      confirmButtonKind="attention"
      width="400px"
    >
      <Box px="24px" py="24px">
        <Typography fontSize="s" letterSpacing="tight" fontWeight="normal">
          {label?.name ? `「${label.name}」を削除してもよろしいですか？` : 'このラベルを削除してもよろしいですか？'}
        </Typography>
      </Box>
    </PopupTemplate>
  )
}
